// removed by extract-text-webpack-plugin
module.exports = {"message-message":"_1_q44uRliXosqm0vCj3spZ","message-close-wrapper":"_2VSC07Hp0echCHKFsVmSNz","message-close-icon":"_11dlqUziZ2yIzywQIQ21Qp"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Message/styles.css
// module id = 1528
// module chunks = 0